import { withInstall } from '@fx-front-framework/utils/with-install'
import VLineChart from './src/index.vue'

export const FxVLineChart = withInstall(VLineChart)
export default FxVLineChart

export * from './src/types'
